<template>

  <brand-layout>
    <brand-item v-for="brand in trash" :key="trash.id" :brand="brand" :restore-with="restoreBrand"
                :remove-with="deleteBrand"/>
    <div v-if="trash.length == 0" class="col-lg-12">
      <p class="text-center h4 mt-4 ">هیچ موردی یافت نشد.</p>
    </div>

    <b-col lg="12" class="text-center my-3">
      <m-pagination-400 class="text-center" :meta="pagination" :on-change-page="changePage"/>
    </b-col>

  </brand-layout>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import brandItem from './item';
import BrandLayout from './layout'

export default {
  name: "Trash",
  components: {brandItem, BrandLayout},
  computed: {
    ...mapGetters({
      trash: 'Brand/getTrash',
      pagination: 'Brand/getPagination',
    })
  },
  methods: {
    ...mapActions({
      deleteBrand: 'Brand/deleteBrand',
      restoreBrand: 'Brand/restore'
    }),
    changePage(page) {
      this.$store.dispatch("Brand/getTrash", page);
      const currentRoute = this.$route
      this.$router.push({name: currentRoute.name, query: {...currentRoute.query, page: page}})
    },
  },
  mounted() {
    let page = 1;
    if (this.$route.query.page != undefined) {
      page = this.$route.query.page
    }
    this.$store.dispatch('Brand/getTrash', page)
  }
}
</script>

<style scoped>

</style>